import { useState } from "react";
import { isDateControl, rankWith, updateErrors } from "@jsonforms/core";
import {
  withJsonFormsControlProps,
  withJsonFormsContext,
} from "@jsonforms/react";
import { getMonthDayYearDate } from "../../../services/dateService";

import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import SFDatePicker from "../../datePicker";

const DatePickerRenderer = (props) => {
  const { uischema, data, path, handleChange } = props.props;
  const { dispatch } = props.ctx;
  const [errors, setErrors] = useState([]);

  const handleNewError = (err) => {
    const errorConfig = err
      ? [
        {
          keyword: "",
          instancePath: `/${path}`,
          schemaPath: "",
          message: err,
        },
      ]
      : [];
    setErrors(errorConfig);
    dispatch(updateErrors(errorConfig));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <SFDatePicker
        disablePast={uischema.options?.disablePast}
        shouldDisableDate={(date) =>
          uischema.options?.disablePresent &&
          getMonthDayYearDate(date) === getMonthDayYearDate(moment())
        }
        disableFuture={uischema.options?.disableFuture}
        label={uischema.label}
        value={data ? moment(data) : null}
        onChange={(date) => {
          handleChange(path, date);
          dispatch(updateErrors(errors));
        }}
        onError={handleNewError}
        {...(uischema.dateFormatter && {
          dateFormatter: uischema.dateFormatter,
        })}
      />
    </LocalizationProvider>
  );
};

export const DatePickerTester = rankWith(101, isDateControl);

export default withJsonFormsControlProps(
  withJsonFormsContext(DatePickerRenderer)
);
